import { render, staticRenderFns } from "./ViewTemplate.vue?vue&type=template&id=212e953a&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewTemplate.vue?vue&type=style&index=0&id=212e953a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e953a",
  null
  
)

export default component.exports